import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import { ModalService } from "@app/services/modal.service";


@Component({
  selector: "app-modal-template",
  templateUrl: "./modal-template.component.html",
  styleUrls: ["./modal-template.component.scss"],
})
export class ModalTemplateComponent implements OnInit {

  @Output() closed: EventEmitter<boolean> = new EventEmitter();
  constructor(public modal: ModalService) {}

  ngOnInit(): void {}

  ngOnDestroy() {
    this.modal.close();
  }

  closeModal() {
    this.closed.emit(true);
    this.modal.close()
  }
}
